import { FC } from 'react';
import styled from 'styled-components';

import { ReactComponent as NoteIcon } from 'assets/icons/edit-note.svg';

import SVG from 'shared/components/SVG';
import { SPAN } from 'shared/components/Typography';
import { Spacer } from 'shared/components/Layout';
import { Wrapper } from 'shared/components/Wrapper';
import { lynch, nevada } from 'shared/config/Colors';

interface CoverSheetNoteItemProps {
  version?: number;
  note: string;
}

const CoverSheetNoteContainer = styled(Wrapper)`
  background-color: ${({ theme }) => theme.wildSandTwo};
  border-radius: 5px;
  padding: 20px 30px;

  > ${SPAN} {
    padding-top: 2px;
  }
`;

export const CoverSheetNoteItem: FC<CoverSheetNoteItemProps> = ({
  version,
  note,
}) => {
  return (
    <CoverSheetNoteContainer flex middle>
      <SVG icon={<NoteIcon />} color={lynch} />

      <Spacer w="20px" />

      {version && (
        <>
          <SPAN color={lynch} fontWeight={600}>
            v{version}
          </SPAN>

          <Spacer w="10px" />
        </>
      )}

      <SPAN color={lynch} fontWeight={600}>
        Note from the CSR:
      </SPAN>

      <Spacer w="5px" />

      <SPAN color={nevada}>{note}</SPAN>
    </CoverSheetNoteContainer>
  );
};
